import React from "react";

import { useNavigate } from "react-router-dom";
import { postMetrics } from "service/api";
import useForm from "hooks/useForm";
import * as yup from "yup";
import { Column, Row, Img, Text, Input, SelectBox, Button } from "components";

const CreateMetricsPage = () => {
  const [apiData1, setapiData1] = React.useState();
  const formValidationSchema = yup
    .object()
    .shape({ name: yup.string().required("Name is required") });
  const form = useForm(
    { name: "" },
    {
      validate: true,
      validateSchema: formValidationSchema,
      validationOnChange: true,
    }
  );
  const navigate = useNavigate();

  function callApi1(data) {
    const req = { data: { ...data } };

    postMetrics(req)
      .then((res) => {
        setapiData1(res);

        navigate("/dashboard");
      })
      .catch((err) => {
        console.error(err);
      });
  }
  function handleNavigate1() {
    navigate("/dashboard");
  }

  return (
    <>
      <Column className="bg-white_A700 font-inter mx-[auto] lg:p-[35px] xl:p-[40px] 2xl:p-[45px] 3xl:p-[54px] w-[100%]">
        <Column className="items-center lg:ml-[31px] xl:ml-[36px] 2xl:ml-[41px] 3xl:ml-[49px] w-[93%]">
          <Row className="items-center w-[100%]">
            <Img
              src="images/img_group.svg"
              className="lg:h-[28px] xl:h-[32px] 2xl:h-[36px] 3xl:h-[43px] w-[13%]"
              alt="Group"
            />
            <Text
              className="common-pointer font-medium lg:ml-[637px] xl:ml-[729px] 2xl:ml-[820px] 3xl:ml-[984px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900_87 w-[auto]"
              onClick={handleNavigate1}
            >
              Dashboard
            </Text>
            <Text className="font-medium lg:ml-[38px] xl:ml-[43px] 2xl:ml-[49px] 3xl:ml-[58px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-blue_A700 w-[auto]">
              Create Metrics
            </Text>
          </Row>
        </Column>
        <Text className="font-bold lg:ml-[31px] xl:ml-[36px] 2xl:ml-[41px] 3xl:ml-[49px] lg:mt-[49px] xl:mt-[56px] 2xl:mt-[63px] 3xl:mt-[75px] lg:text-[24px] xl:text-[28px] 2xl:text-[32px] 3xl:text-[38px] text-black_900 w-[auto]">
          Create Metrics
        </Text>
        <Column className="items-center lg:mb-[52px] xl:mb-[60px] 2xl:mb-[68px] 3xl:mb-[81px] lg:ml-[31px] xl:ml-[36px] 2xl:ml-[41px] 3xl:ml-[49px] lg:mt-[50px] xl:mt-[57px] 2xl:mt-[65px] 3xl:mt-[78px] lg:px-[212px] xl:px-[242px] 2xl:px-[273px] 3xl:px-[327px] w-[93%]">
          <Column className="bg-white_A700 justify-end lg:p-[24px] xl:p-[27px] 2xl:p-[31px] 3xl:p-[37px] rounded-radius12 shadow-bs w-[95%]">
            <Column className="ml-[1px] lg:mt-[22px] xl:mt-[25px] 2xl:mt-[29px] 3xl:mt-[34px] rounded-radius8 w-[96%]">
              <Text className="font-medium lg:text-[18px] xl:text-[21px] 2xl:text-[24px] 3xl:text-[28px] text-black_900 w-[auto]">
                Metrics Name
              </Text>
              <Input
                className="rounded-radius8 w-[100%]"
                wrapClassName="2xl:h-[49px] 2xl:mt-[20px] 3xl:h-[58px] 3xl:mt-[24px] flex lg:h-[38px] lg:mt-[15px] w-[100%] xl:h-[43px] xl:mt-[17px]"
                onChange={(e) => {
                  form.handleChange("name", e.target.value);
                }}
                errors={form?.errors?.name}
                value={form?.values?.name}
                name="RectangleThirtySeven"
                placeholder=""
              ></Input>
            </Column>
            <Text className="font-medium ml-[2px] lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] lg:text-[18px] xl:text-[21px] 2xl:text-[24px] 3xl:text-[28px] text-black_900 w-[auto]">
              Sub-categories
            </Text>
            <SelectBox
              className="font-normal ml-[1px] lg:mt-[10px] xl:mt-[11px] 2xl:mt-[13px] 3xl:mt-[15px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-bluegray_400 w-[96%]"
              placeholderClassName="text-bluegray_400"
              name="Group226"
              placeholder="--select one--"
              isSearchable={false}
              isMulti={false}
              indicator={
                <Img
                  src="images/img_arrowdown.svg"
                  className="lg:w-[8px] lg:h-[5px] lg:mr-[20px] xl:w-[9px] xl:h-[6px] xl:mr-[23px] 2xl:w-[11px] 2xl:h-[7px] 2xl:mr-[26px] 3xl:w-[13px] 3xl:h-[8px] 3xl:mr-[31px]"
                  alt="arrow_down"
                />
              }
            ></SelectBox>
            <Text className="font-medium ml-[2px] lg:mt-[35px] xl:mt-[40px] 2xl:mt-[45px] 3xl:mt-[54px] lg:text-[18px] xl:text-[21px] 2xl:text-[24px] 3xl:text-[28px] text-black_900 w-[auto]">
              Goals
            </Text>
            <SelectBox
              className="font-normal ml-[1px] lg:mt-[13px] xl:mt-[15px] 2xl:mt-[17px] 3xl:mt-[20px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-bluegray_400 w-[96%]"
              placeholderClassName="text-bluegray_400"
              name="Group226 One"
              placeholder="--select one--"
              isSearchable={false}
              isMulti={false}
              indicator={
                <Img
                  src="images/img_arrowdown.svg"
                  className="lg:w-[8px] lg:h-[5px] lg:mr-[20px] xl:w-[9px] xl:h-[6px] xl:mr-[23px] 2xl:w-[11px] 2xl:h-[7px] 2xl:mr-[26px] 3xl:w-[13px] 3xl:h-[8px] 3xl:mr-[31px]"
                  alt="arrow_down"
                />
              }
            ></SelectBox>
            <Column className="ml-[2px] lg:mt-[35px] xl:mt-[40px] 2xl:mt-[45px] 3xl:mt-[54px] rounded-radius8 w-[96%]">
              <Text className="font-medium lg:text-[18px] xl:text-[21px] 2xl:text-[24px] 3xl:text-[28px] text-black_900 w-[auto]">
                Month
              </Text>
              <Input
                className="rounded-radius8 w-[100%]"
                wrapClassName="2xl:h-[49px] 2xl:mt-[20px] 3xl:h-[58px] 3xl:mt-[24px] flex lg:h-[38px] lg:mt-[15px] w-[100%] xl:h-[43px] xl:mt-[17px]"
                name="RectangleThirtySeven One"
                placeholder=""
              ></Input>
            </Column>
            <Button
              className="common-pointer font-normal ml-[2px] lg:mt-[38px] xl:mt-[43px] 2xl:mt-[49px] 3xl:mt-[58px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-center w-[16%]"
              onClick={() => {
                form.handleSubmit(callApi1);
              }}
            >
              Submit
            </Button>
          </Column>
        </Column>
      </Column>
    </>
  );
};

export default CreateMetricsPage;
